'use strict';

var framerMotion = require('framer-motion');
var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Transition_module = require('../styles/Transition.module.less.js');
var _utils = require('./_utils.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const hasHeightValue = (value) => value != null && parseInt(value.toString(), 10) > 0;
const variants = {
    exit: (props) => props.withAnimation
        ? {
            ...(props.animateOpacity && {
                opacity: hasHeightValue(props.startingHeight) ? 1 : 0,
            }),
            height: props.startingHeight,
            transition: {
                height: { duration: 0.2, ease: _utils.EASINGS.ease },
                opacity: { duration: 0.3, ease: _utils.EASINGS.ease },
            },
        }
        : {},
    enter: (props) => props.withAnimation
        ? {
            ...(props.animateOpacity && {
                opacity: 1,
            }),
            height: props.endingHeight,
            transition: {
                height: {
                    duration: 0.3,
                    ease: _utils.EASINGS.ease,
                },
                opacity: {
                    duration: 0.4,
                    ease: _utils.EASINGS.ease,
                },
            },
            transitionEnd: { display: null },
        }
        : {},
};
const Collapse = React__namespace.forwardRef((props, ref) => {
    const { unmountOnExit, visible, enableAnimation = true, animateOpacity = true, startingHeight = 0, endingHeight = 'auto', className, onAnimationComplete, ...rest } = props;
    const cx = reactUtils.useStyles(Transition_module.default);
    const fromZeroHeight = startingHeight === 0;
    const [open, setOpen] = React__namespace.useState(!!visible);
    const getInitialHidden = () => {
        // If it is open by default, no need to apply `aria-hidden`
        if (visible)
            return false;
        // If startingHeight > 0, then content is partially visible
        if (hasHeightValue(startingHeight))
            return false;
        // Else, the content is hidden
        return true;
    };
    const [display, setDisplay] = React__namespace.useState(() => {
        if (!fromZeroHeight)
            return true;
        const hidden = getInitialHidden();
        return !hidden;
    });
    const collapseClassnames = cx(className, 'collapse-overflow', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'collapse-visible': display === true,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'collapse-hidden': display === false,
    });
    const custom = {
        startingHeight,
        endingHeight,
        animateOpacity,
        withAnimation: enableAnimation,
    };
    const ownProps = {
        ref,
        // @future: set parameter as `definition` when we remove `framer-motion`
        // v3 support
        onAnimationComplete: (definition) => {
            if (definition === 'exit' && !open && fromZeroHeight) {
                setDisplay(false);
            }
            definition && onAnimationComplete?.(definition);
        },
        ...rest,
        variants,
        custom,
    };
    React__namespace.useEffect(() => {
        if (visible) {
            setDisplay(true);
        }
        else {
            !enableAnimation && setDisplay(false);
        }
        setOpen(!!visible);
    }, [visible, enableAnimation]);
    if (unmountOnExit) {
        return (React__namespace.createElement(framerMotion.AnimatePresence, { initial: false, custom: custom }, visible && (
        // @ts-ignore
        React__namespace.createElement(framerMotion.motion.div, { ...ownProps, className: collapseClassnames, initial: "exit", animate: "enter", exit: "exit" }))));
    }
    // @ts-ignore
    return React__namespace.createElement(framerMotion.motion.div, { ...ownProps, className: collapseClassnames, initial: false, animate: open ? 'enter' : 'exit' });
});
Collapse.defaultProps = {
    animateOpacity: true,
    startingHeight: 0,
    endingHeight: 'auto',
    enableAnimation: true,
};
Collapse.displayName = 'Collapse';

exports.Collapse = Collapse;
//# sourceMappingURL=Collapse.js.map
